export default __webpack_public_path__ + "static/media/instagram.ddcaf3c4.png";